<span class="instructor-title">{{ instructor.firstName }} {{ instructor.lastName }}</span>
<vnm-email-address [email]="instructor.email"></vnm-email-address>
